import { Component, OnInit, Input } from '@angular/core';
import { MessagesAddEditComponent } from './parts/add-edit/add-edit.component';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss']
})
export class MessagesComponent implements OnInit {

  @Input() object: Object;
  @Input() summaryOnly: boolean = false;
  public key: string;
  public extraData: Object;

  constructor() { }

  ngOnInit(): void {

    this.key = 'message';
    this.extraData = {
      heading: this.object['title']['rendered'],
      component: MessagesAddEditComponent,
      showSummaryOnly: this.showSummaryOnly(),
      options: {
        class: 'modal-lg'
      },
      section: {
        key: 'message',
        title: 'Messages',
        type: 'children',
        childType: 'message',
        plural: 'messages',
        singular: 'Message',
        min: 0,
        max: 0,
      },
    }

  }

  showSummaryOnly() {

    if( typeof( this.object ) === 'undefined' ) {
      return true;
    }

    return this.summaryOnly;

  }

}
